import { axiosNode } from '../config/axiosConfig';
import { manejarErrorServicio } from '../utils/errorHandlerUtil';

const RUTA_BASE = 'tipos-novedades';

export default {
  async buscarTodos(filtros) {
    try {
      const params = getQueryParamsBuscarTodos(filtros);
      const response = await axiosNode.get(RUTA_BASE, { params });
      return response.data;
    } catch (error) {
      return await manejarErrorServicio(error);
    }
  },
};

const getQueryParamsBuscarTodos = (filtros = null) => {
  if (!filtros) return {};

  const { estaActivo } = filtros;

  const params = {};
  if (estaActivo !== null) {
    params.estaActivo = estaActivo;
  }
  return params;
};
